
/**
 * Formats a date into a readable string
 */
export const formatDate = (date: Date | string): string => {
  if (!date) return "";
  
  // Convert to Date if it's a string
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  // Format the date as MM/DD/YYYY
  return dateObj.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  });
};

/**
 * Converts a Date to string format for API calls
 */
export const dateToString = (date: Date | string): string => {
  if (!date) return "";
  
  // If already a string, return it
  if (typeof date === 'string') return date;
  
  // Convert Date to ISO string and take just the date part
  return date.toISOString().split('T')[0];
};
